/**
 * Swiper React 6.8.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 16, 2021
 */

import { Swiper } from './esm/react/swiper';
import { SwiperSlide } from './esm/react/swiper-slide';
export { Swiper, SwiperSlide };
